<template>
    <ValidationObserver ref="validationObserver" slim>
        <div class="forms-feature__form-wrapper">

            <ValidationProvider :vid="$id('vid')" name="Bereich" rules="required" v-slot="{ errors }" slim>
                <div class="migrol-form__input-wrapper" :class="{ 'migrol-form__input-wrapper--error' : errors.length > 0 }">
                    <ContactAreaPicker :options="contactAreas"
                                       v-model="selectedArea" />
                    <div class="migrol-form__error-message">{{errors[0]}}</div>
                </div>
            </ValidationProvider>
            <div v-if="selectedArea" class="forms-feature__contact-area-desc">
                {{selectedArea.desc}}
            </div>

            <div class="forms-feature__field-block" v-if="!IsClientKnown">
                <div class="forms-feature__field-block-title">{{Strings['Global.Address.ContactAddress']}}</div>
                <Address />
            </div>

            <div class="forms-feature__field-block" v-if="selectedArea && selectedArea.key == 'EMobility'">
                <div class="forms-feature__field-row">
                    <SelectWithLabel v-model="eMobilityCategory"
                                     :label="Strings['Forms.Contact.EMobility.Category']"
                                     rules="required"
                                     :options="eMobilityCategoryOptions" />
                </div>
            </div>

            <div class="forms-feature__field-block">
                <div class="forms-feature__field-block-title">{{Strings['Forms.CommentsTitle']}}</div>
                <div class="forms-feature__field-row">
                    <Comments :showlabel="false" />
                </div>
            </div>
            <div class="forms-feature__field-block forms-feature__field-block--no-separator">
                <div class="forms-feature__field-row">
                    <DSE v-model="dseAccepted" />
                </div>
            </div>

            <ServerErrorMessageList />

            <div class="migrol-form__buttons">
                <AjaxButton :isWaitingForAjax="isWaitingForAjax" :label="Strings['Forms.Submit']" @buttonClick="submitForm" cssclass="migrol-form__button--green" />
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex'
    import $ from 'jQuery'
    import Address from '../_common/Address'
    import ContactAreaPicker from './ContactAreaPicker'
    import Comments from '../_common/Comments'
    import ServerErrorMessageList from '../_common/ServerErrorMessageList'
    import { ValidationObserver } from 'VeeValidate'
    import { ValidationProvider } from 'VeeValidate'
    import { doValidation, getEnumOptions } from '@/utils/utils'

    export default {
        data() {
            return {
                selectedArea: null,
                contactAreas: [
                    { key: 'Energy', name: this.$store.state.Strings['Forms.Contact.AreaEnergyName'], desc: this.$store.state.Strings['Forms.Contact.AreaEnergyDesc'] },
                    { key: 'Mobility', name: this.$store.state.Strings['Forms.Contact.AreaMobilityName'], desc: this.$store.state.Strings['Forms.Contact.AreaMobilityDesc'] },
                    { key: 'Migrolcard', name: this.$store.state.Strings['Forms.Contact.AreaMigrolcardName'], desc: this.$store.state.Strings['Forms.Contact.AreaMigrolcardDesc'] },
                    { key: 'EMobility', name: this.$store.state.Strings['Forms.Contact.AreaEMobilityName'], desc: this.$store.state.Strings['Forms.Contact.AreaEMobilityDesc'] },
                    { key: 'Media', name: this.$store.state.Strings['Forms.Contact.AreaMediaName'], desc: this.$store.state.Strings['Forms.Contact.AreaMediaDesc'] },
                    { key: 'Other', name: this.$store.state.Strings['Forms.Contact.AreaOtherName'], desc: this.$store.state.Strings['Forms.Contact.AreaOtherDesc'] }
                ]
            }
        },
        computed: {
            ...mapState([
                'Strings',
                'Enums',
                'IsClientKnown'
            ]),
            ...mapGetters([
                'isWaitingForAjax'
            ]),            
            dseAccepted: {
                get() { return this.$store.state.dseAccepted; },
                set(val) { this.$store.commit('setDseAccepted', val); }
            },
            sendMeCopy: {
                get() { return this.$store.state.contact.sendMeCopy; },
                set(val) { this.$store.commit('contact/setSendMecopy', val); }
            },
            eMobilityCategory: {
                get() { return this.$store.state.contact.eMobilityCategory; },
                set(val) { this.$store.commit('contact/setEMobilityCategory', val); }
            },
            eMobilityCategoryOptions() {
                return getEnumOptions(this.Enums["ContactEMobilityCategories"]);
            }
        },
        methods: {
            ...mapActions([
                'TriggerGoal'
            ]),
            submitForm() {
                let formData = { ...this.$store.getters['baseData'], ...this.$store.state.contact };
                var vm = this;
                doValidation(vm.$refs.validationObserver, () => {
                    vm.$store.commit('clearServerErrormessages');
                    vm.$store.commit('increasePendingAjaxCalls');
                    $.post({
                        url: '/migrolapi/' + window.CONFIG.language + '/forms/SubmitContactForm',
                        data: JSON.stringify(formData),
                        contentType: 'application/json'
                    })
                        .done((response) => {
                            if (!response.Success)
                                vm.manageError(response);
                            else {
                                var selectedEmobiThemaText = '';
                                if (vm.selectedArea && vm.selectedArea.key == 'EMobility') {
                                    var selectedEmobiThema = vm.eMobilityCategoryOptions.filter(x => x.id == vm.eMobilityCategory);
                                    selectedEmobiThemaText = selectedEmobiThema.length > 0 ? selectedEmobiThema[0].text : '';
                                }
                                if (window.dataLayer) {
                                    window.dataLayer.push({
                                        event: 'contactform',  
                                        formname: 'Kontaktformular',
                                        formthema: selectedEmobiThemaText
                                    });
                                }
                                this.$router.push('/thanks').catch(() => { });
                                vm.TriggerGoal();
                            }
                        })
                        .fail(() => {
                            vm.manageError(null);
                        })
                        .always(function () {
                            vm.$store.commit('decreasePendingAjaxCalls');
                        });
                });
            },
            manageError(response) {
                if (!response || !response.ErrorMessages || response.ErrorMessages.length == 0)
                    this.$store.commit('addServerErrormessages', [{ TextKey: 'Shop.Errors.GenericError' }]);
                else
                    this.$store.commit('addServerErrormessages', response.ErrorMessages);
            }
        },
        watch: {
            selectedArea(newValue) {
                this.$store.commit('contact/setArea', newValue.key);
            }
        },
        components: {
            Address,
            ValidationObserver,
            ValidationProvider,
            ContactAreaPicker,
            Comments,
            ServerErrorMessageList
        }
    };
</script>